// Lista fixa de zonas IANA para Combos; o valor e tecnico e o texto e localizado.
export default {
  options: [
  {
    "value": "UTC",
    "text": "UTC"
  },
  {
    "value": "Africa/Abidjan",
    "text": "África / Abidjan"
  },
  {
    "value": "Africa/Accra",
    "text": "África / Accra"
  },
  {
    "value": "Africa/Addis_Ababa",
    "text": "África / Addis Ababa"
  },
  {
    "value": "Africa/Algiers",
    "text": "África / Algiers"
  },
  {
    "value": "Africa/Asmera",
    "text": "África / Asmera"
  },
  {
    "value": "Africa/Bamako",
    "text": "África / Bamako"
  },
  {
    "value": "Africa/Bangui",
    "text": "África / Bangui"
  },
  {
    "value": "Africa/Banjul",
    "text": "África / Banjul"
  },
  {
    "value": "Africa/Bissau",
    "text": "África / Bissau"
  },
  {
    "value": "Africa/Blantyre",
    "text": "África / Blantyre"
  },
  {
    "value": "Africa/Brazzaville",
    "text": "África / Brazzaville"
  },
  {
    "value": "Africa/Bujumbura",
    "text": "África / Bujumbura"
  },
  {
    "value": "Africa/Cairo",
    "text": "África / Cairo"
  },
  {
    "value": "Africa/Casablanca",
    "text": "África / Casablanca"
  },
  {
    "value": "Africa/Ceuta",
    "text": "África / Ceuta"
  },
  {
    "value": "Africa/Conakry",
    "text": "África / Conakry"
  },
  {
    "value": "Africa/Dakar",
    "text": "África / Dakar"
  },
  {
    "value": "Africa/Dar_es_Salaam",
    "text": "África / Dar Es Salaam"
  },
  {
    "value": "Africa/Djibouti",
    "text": "África / Djibouti"
  },
  {
    "value": "Africa/Douala",
    "text": "África / Douala"
  },
  {
    "value": "Africa/El_Aaiun",
    "text": "África / El Aaiun"
  },
  {
    "value": "Africa/Freetown",
    "text": "África / Freetown"
  },
  {
    "value": "Africa/Gaborone",
    "text": "África / Gaborone"
  },
  {
    "value": "Africa/Harare",
    "text": "África / Harare"
  },
  {
    "value": "Africa/Johannesburg",
    "text": "África / Johannesburg"
  },
  {
    "value": "Africa/Juba",
    "text": "África / Juba"
  },
  {
    "value": "Africa/Kampala",
    "text": "África / Kampala"
  },
  {
    "value": "Africa/Khartoum",
    "text": "África / Khartoum"
  },
  {
    "value": "Africa/Kigali",
    "text": "África / Kigali"
  },
  {
    "value": "Africa/Kinshasa",
    "text": "África / Kinshasa"
  },
  {
    "value": "Africa/Lagos",
    "text": "África / Lagos"
  },
  {
    "value": "Africa/Libreville",
    "text": "África / Libreville"
  },
  {
    "value": "Africa/Lome",
    "text": "África / Lome"
  },
  {
    "value": "Africa/Luanda",
    "text": "África / Luanda"
  },
  {
    "value": "Africa/Lubumbashi",
    "text": "África / Lubumbashi"
  },
  {
    "value": "Africa/Lusaka",
    "text": "África / Lusaka"
  },
  {
    "value": "Africa/Malabo",
    "text": "África / Malabo"
  },
  {
    "value": "Africa/Maputo",
    "text": "África / Maputo"
  },
  {
    "value": "Africa/Maseru",
    "text": "África / Maseru"
  },
  {
    "value": "Africa/Mbabane",
    "text": "África / Mbabane"
  },
  {
    "value": "Africa/Mogadishu",
    "text": "África / Mogadishu"
  },
  {
    "value": "Africa/Monrovia",
    "text": "África / Monrovia"
  },
  {
    "value": "Africa/Nairobi",
    "text": "África / Nairobi"
  },
  {
    "value": "Africa/Ndjamena",
    "text": "África / Ndjamena"
  },
  {
    "value": "Africa/Niamey",
    "text": "África / Niamey"
  },
  {
    "value": "Africa/Nouakchott",
    "text": "África / Nouakchott"
  },
  {
    "value": "Africa/Ouagadougou",
    "text": "África / Ouagadougou"
  },
  {
    "value": "Africa/Porto-Novo",
    "text": "África / Porto-Novo"
  },
  {
    "value": "Africa/Sao_Tome",
    "text": "África / Sao Tome"
  },
  {
    "value": "Africa/Tripoli",
    "text": "África / Tripoli"
  },
  {
    "value": "Africa/Tunis",
    "text": "África / Tunis"
  },
  {
    "value": "Africa/Windhoek",
    "text": "África / Windhoek"
  },
  {
    "value": "America/Adak",
    "text": "América / Adak"
  },
  {
    "value": "America/Anchorage",
    "text": "América / Anchorage"
  },
  {
    "value": "America/Anguilla",
    "text": "América / Anguilla"
  },
  {
    "value": "America/Antigua",
    "text": "América / Antigua"
  },
  {
    "value": "America/Araguaina",
    "text": "América / Brasil / Araguaina"
  },
  {
    "value": "America/Argentina/La_Rioja",
    "text": "América / Argentina / La Rioja"
  },
  {
    "value": "America/Argentina/Rio_Gallegos",
    "text": "América / Argentina / Rio Gallegos"
  },
  {
    "value": "America/Argentina/Salta",
    "text": "América / Argentina / Salta"
  },
  {
    "value": "America/Argentina/San_Juan",
    "text": "América / Argentina / San Juan"
  },
  {
    "value": "America/Argentina/San_Luis",
    "text": "América / Argentina / San Luis"
  },
  {
    "value": "America/Argentina/Tucuman",
    "text": "América / Argentina / Tucuman"
  },
  {
    "value": "America/Argentina/Ushuaia",
    "text": "América / Argentina / Ushuaia"
  },
  {
    "value": "America/Aruba",
    "text": "América / Aruba"
  },
  {
    "value": "America/Asuncion",
    "text": "América / Asuncion"
  },
  {
    "value": "America/Bahia",
    "text": "América / Brasil / Bahia"
  },
  {
    "value": "America/Bahia_Banderas",
    "text": "América / Bahia Banderas"
  },
  {
    "value": "America/Barbados",
    "text": "América / Barbados"
  },
  {
    "value": "America/Belem",
    "text": "América / Brasil / Belem"
  },
  {
    "value": "America/Belize",
    "text": "América / Belize"
  },
  {
    "value": "America/Blanc-Sablon",
    "text": "América / Blanc-Sablon"
  },
  {
    "value": "America/Boa_Vista",
    "text": "América / Brasil / Boa Vista"
  },
  {
    "value": "America/Bogota",
    "text": "América / Bogota"
  },
  {
    "value": "America/Boise",
    "text": "América / Boise"
  },
  {
    "value": "America/Buenos_Aires",
    "text": "América / Buenos Aires"
  },
  {
    "value": "America/Cambridge_Bay",
    "text": "América / Cambridge Bay"
  },
  {
    "value": "America/Campo_Grande",
    "text": "América / Brasil / Campo Grande"
  },
  {
    "value": "America/Cancun",
    "text": "América / Cancun"
  },
  {
    "value": "America/Caracas",
    "text": "América / Caracas"
  },
  {
    "value": "America/Catamarca",
    "text": "América / Catamarca"
  },
  {
    "value": "America/Cayenne",
    "text": "América / Cayenne"
  },
  {
    "value": "America/Cayman",
    "text": "América / Cayman"
  },
  {
    "value": "America/Chicago",
    "text": "América / Chicago"
  },
  {
    "value": "America/Chihuahua",
    "text": "América / Chihuahua"
  },
  {
    "value": "America/Ciudad_Juarez",
    "text": "América / Ciudad Juarez"
  },
  {
    "value": "America/Coral_Harbour",
    "text": "América / Coral Harbour"
  },
  {
    "value": "America/Cordoba",
    "text": "América / Cordoba"
  },
  {
    "value": "America/Costa_Rica",
    "text": "América / Costa Rica"
  },
  {
    "value": "America/Coyhaique",
    "text": "América / Coyhaique"
  },
  {
    "value": "America/Creston",
    "text": "América / Creston"
  },
  {
    "value": "America/Cuiaba",
    "text": "América / Brasil / Cuiaba"
  },
  {
    "value": "America/Curacao",
    "text": "América / Curacao"
  },
  {
    "value": "America/Danmarkshavn",
    "text": "América / Danmarkshavn"
  },
  {
    "value": "America/Dawson",
    "text": "América / Dawson"
  },
  {
    "value": "America/Dawson_Creek",
    "text": "América / Dawson Creek"
  },
  {
    "value": "America/Denver",
    "text": "América / Denver"
  },
  {
    "value": "America/Detroit",
    "text": "América / Detroit"
  },
  {
    "value": "America/Dominica",
    "text": "América / Dominica"
  },
  {
    "value": "America/Edmonton",
    "text": "América / Edmonton"
  },
  {
    "value": "America/Eirunepe",
    "text": "América / Brasil / Eirunepe"
  },
  {
    "value": "America/El_Salvador",
    "text": "América / El Salvador"
  },
  {
    "value": "America/Fort_Nelson",
    "text": "América / Fort Nelson"
  },
  {
    "value": "America/Fortaleza",
    "text": "América / Brasil / Fortaleza"
  },
  {
    "value": "America/Glace_Bay",
    "text": "América / Glace Bay"
  },
  {
    "value": "America/Godthab",
    "text": "América / Godthab"
  },
  {
    "value": "America/Goose_Bay",
    "text": "América / Goose Bay"
  },
  {
    "value": "America/Grand_Turk",
    "text": "América / Grand Turk"
  },
  {
    "value": "America/Grenada",
    "text": "América / Grenada"
  },
  {
    "value": "America/Guadeloupe",
    "text": "América / Guadeloupe"
  },
  {
    "value": "America/Guatemala",
    "text": "América / Guatemala"
  },
  {
    "value": "America/Guayaquil",
    "text": "América / Guayaquil"
  },
  {
    "value": "America/Guyana",
    "text": "América / Guyana"
  },
  {
    "value": "America/Halifax",
    "text": "América / Halifax"
  },
  {
    "value": "America/Havana",
    "text": "América / Havana"
  },
  {
    "value": "America/Hermosillo",
    "text": "América / Hermosillo"
  },
  {
    "value": "America/Indiana/Knox",
    "text": "América / Indiana / Knox"
  },
  {
    "value": "America/Indiana/Marengo",
    "text": "América / Indiana / Marengo"
  },
  {
    "value": "America/Indiana/Petersburg",
    "text": "América / Indiana / Petersburg"
  },
  {
    "value": "America/Indiana/Tell_City",
    "text": "América / Indiana / Tell City"
  },
  {
    "value": "America/Indiana/Vevay",
    "text": "América / Indiana / Vevay"
  },
  {
    "value": "America/Indiana/Vincennes",
    "text": "América / Indiana / Vincennes"
  },
  {
    "value": "America/Indiana/Winamac",
    "text": "América / Indiana / Winamac"
  },
  {
    "value": "America/Indianapolis",
    "text": "América / Indianapolis"
  },
  {
    "value": "America/Inuvik",
    "text": "América / Inuvik"
  },
  {
    "value": "America/Iqaluit",
    "text": "América / Iqaluit"
  },
  {
    "value": "America/Jamaica",
    "text": "América / Jamaica"
  },
  {
    "value": "America/Jujuy",
    "text": "América / Jujuy"
  },
  {
    "value": "America/Juneau",
    "text": "América / Juneau"
  },
  {
    "value": "America/Kentucky/Monticello",
    "text": "América / Kentucky / Monticello"
  },
  {
    "value": "America/Kralendijk",
    "text": "América / Kralendijk"
  },
  {
    "value": "America/La_Paz",
    "text": "América / La Paz"
  },
  {
    "value": "America/Lima",
    "text": "América / Lima"
  },
  {
    "value": "America/Los_Angeles",
    "text": "América / Los Angeles"
  },
  {
    "value": "America/Louisville",
    "text": "América / Louisville"
  },
  {
    "value": "America/Lower_Princes",
    "text": "América / Lower Princes"
  },
  {
    "value": "America/Maceio",
    "text": "América / Brasil / Maceio"
  },
  {
    "value": "America/Managua",
    "text": "América / Managua"
  },
  {
    "value": "America/Manaus",
    "text": "América / Brasil / Manaus"
  },
  {
    "value": "America/Marigot",
    "text": "América / Marigot"
  },
  {
    "value": "America/Martinique",
    "text": "América / Martinique"
  },
  {
    "value": "America/Matamoros",
    "text": "América / Matamoros"
  },
  {
    "value": "America/Mazatlan",
    "text": "América / Mazatlan"
  },
  {
    "value": "America/Mendoza",
    "text": "América / Mendoza"
  },
  {
    "value": "America/Menominee",
    "text": "América / Menominee"
  },
  {
    "value": "America/Merida",
    "text": "América / Merida"
  },
  {
    "value": "America/Metlakatla",
    "text": "América / Metlakatla"
  },
  {
    "value": "America/Mexico_City",
    "text": "América / Mexico City"
  },
  {
    "value": "America/Miquelon",
    "text": "América / Miquelon"
  },
  {
    "value": "America/Moncton",
    "text": "América / Moncton"
  },
  {
    "value": "America/Monterrey",
    "text": "América / Monterrey"
  },
  {
    "value": "America/Montevideo",
    "text": "América / Montevideo"
  },
  {
    "value": "America/Montserrat",
    "text": "América / Montserrat"
  },
  {
    "value": "America/Nassau",
    "text": "América / Nassau"
  },
  {
    "value": "America/New_York",
    "text": "América / New York"
  },
  {
    "value": "America/Nome",
    "text": "América / Nome"
  },
  {
    "value": "America/Noronha",
    "text": "América / Brasil / Noronha"
  },
  {
    "value": "America/North_Dakota/Beulah",
    "text": "América / North Dakota / Beulah"
  },
  {
    "value": "America/North_Dakota/Center",
    "text": "América / North Dakota / Center"
  },
  {
    "value": "America/North_Dakota/New_Salem",
    "text": "América / North Dakota / New Salem"
  },
  {
    "value": "America/Ojinaga",
    "text": "América / Ojinaga"
  },
  {
    "value": "America/Panama",
    "text": "América / Panama"
  },
  {
    "value": "America/Paramaribo",
    "text": "América / Paramaribo"
  },
  {
    "value": "America/Phoenix",
    "text": "América / Phoenix"
  },
  {
    "value": "America/Port-au-Prince",
    "text": "América / Port-Au-Prince"
  },
  {
    "value": "America/Port_of_Spain",
    "text": "América / Port Of Spain"
  },
  {
    "value": "America/Porto_Velho",
    "text": "América / Brasil / Porto Velho"
  },
  {
    "value": "America/Puerto_Rico",
    "text": "América / Puerto Rico"
  },
  {
    "value": "America/Punta_Arenas",
    "text": "América / Punta Arenas"
  },
  {
    "value": "America/Rankin_Inlet",
    "text": "América / Rankin Inlet"
  },
  {
    "value": "America/Recife",
    "text": "América / Brasil / Recife"
  },
  {
    "value": "America/Regina",
    "text": "América / Regina"
  },
  {
    "value": "America/Resolute",
    "text": "América / Resolute"
  },
  {
    "value": "America/Rio_Branco",
    "text": "América / Brasil / Rio Branco"
  },
  {
    "value": "America/Santarem",
    "text": "América / Brasil / Santarem"
  },
  {
    "value": "America/Santiago",
    "text": "América / Santiago"
  },
  {
    "value": "America/Santo_Domingo",
    "text": "América / Santo Domingo"
  },
  {
    "value": "America/Sao_Paulo",
    "text": "América / Brasil / São Paulo"
  },
  {
    "value": "America/Scoresbysund",
    "text": "América / Scoresbysund"
  },
  {
    "value": "America/Sitka",
    "text": "América / Sitka"
  },
  {
    "value": "America/St_Barthelemy",
    "text": "América / St Barthelemy"
  },
  {
    "value": "America/St_Johns",
    "text": "América / St Johns"
  },
  {
    "value": "America/St_Kitts",
    "text": "América / St Kitts"
  },
  {
    "value": "America/St_Lucia",
    "text": "América / St Lucia"
  },
  {
    "value": "America/St_Thomas",
    "text": "América / St Thomas"
  },
  {
    "value": "America/St_Vincent",
    "text": "América / St Vincent"
  },
  {
    "value": "America/Swift_Current",
    "text": "América / Swift Current"
  },
  {
    "value": "America/Tegucigalpa",
    "text": "América / Tegucigalpa"
  },
  {
    "value": "America/Thule",
    "text": "América / Thule"
  },
  {
    "value": "America/Tijuana",
    "text": "América / Tijuana"
  },
  {
    "value": "America/Toronto",
    "text": "América / Toronto"
  },
  {
    "value": "America/Tortola",
    "text": "América / Tortola"
  },
  {
    "value": "America/Vancouver",
    "text": "América / Vancouver"
  },
  {
    "value": "America/Whitehorse",
    "text": "América / Whitehorse"
  },
  {
    "value": "America/Winnipeg",
    "text": "América / Winnipeg"
  },
  {
    "value": "America/Yakutat",
    "text": "América / Yakutat"
  },
  {
    "value": "Antarctica/Casey",
    "text": "Antártida / Casey"
  },
  {
    "value": "Antarctica/Davis",
    "text": "Antártida / Davis"
  },
  {
    "value": "Antarctica/DumontDUrville",
    "text": "Antártida / DumontDUrville"
  },
  {
    "value": "Antarctica/Macquarie",
    "text": "Antártida / Macquarie"
  },
  {
    "value": "Antarctica/Mawson",
    "text": "Antártida / Mawson"
  },
  {
    "value": "Antarctica/McMurdo",
    "text": "Antártida / McMurdo"
  },
  {
    "value": "Antarctica/Palmer",
    "text": "Antártida / Palmer"
  },
  {
    "value": "Antarctica/Rothera",
    "text": "Antártida / Rothera"
  },
  {
    "value": "Antarctica/Syowa",
    "text": "Antártida / Syowa"
  },
  {
    "value": "Antarctica/Troll",
    "text": "Antártida / Troll"
  },
  {
    "value": "Antarctica/Vostok",
    "text": "Antártida / Vostok"
  },
  {
    "value": "Arctic/Longyearbyen",
    "text": "Ártico / Longyearbyen"
  },
  {
    "value": "Asia/Aden",
    "text": "Ásia / Aden"
  },
  {
    "value": "Asia/Almaty",
    "text": "Ásia / Almaty"
  },
  {
    "value": "Asia/Amman",
    "text": "Ásia / Amman"
  },
  {
    "value": "Asia/Anadyr",
    "text": "Ásia / Anadyr"
  },
  {
    "value": "Asia/Aqtau",
    "text": "Ásia / Aqtau"
  },
  {
    "value": "Asia/Aqtobe",
    "text": "Ásia / Aqtobe"
  },
  {
    "value": "Asia/Ashgabat",
    "text": "Ásia / Ashgabat"
  },
  {
    "value": "Asia/Atyrau",
    "text": "Ásia / Atyrau"
  },
  {
    "value": "Asia/Baghdad",
    "text": "Ásia / Baghdad"
  },
  {
    "value": "Asia/Bahrain",
    "text": "Ásia / Bahrain"
  },
  {
    "value": "Asia/Baku",
    "text": "Ásia / Baku"
  },
  {
    "value": "Asia/Bangkok",
    "text": "Ásia / Bangkok"
  },
  {
    "value": "Asia/Barnaul",
    "text": "Ásia / Barnaul"
  },
  {
    "value": "Asia/Beirut",
    "text": "Ásia / Beirut"
  },
  {
    "value": "Asia/Bishkek",
    "text": "Ásia / Bishkek"
  },
  {
    "value": "Asia/Brunei",
    "text": "Ásia / Brunei"
  },
  {
    "value": "Asia/Calcutta",
    "text": "Ásia / Calcutta"
  },
  {
    "value": "Asia/Chita",
    "text": "Ásia / Chita"
  },
  {
    "value": "Asia/Colombo",
    "text": "Ásia / Colombo"
  },
  {
    "value": "Asia/Damascus",
    "text": "Ásia / Damascus"
  },
  {
    "value": "Asia/Dhaka",
    "text": "Ásia / Dhaka"
  },
  {
    "value": "Asia/Dili",
    "text": "Ásia / Dili"
  },
  {
    "value": "Asia/Dubai",
    "text": "Ásia / Dubai"
  },
  {
    "value": "Asia/Dushanbe",
    "text": "Ásia / Dushanbe"
  },
  {
    "value": "Asia/Famagusta",
    "text": "Ásia / Famagusta"
  },
  {
    "value": "Asia/Gaza",
    "text": "Ásia / Gaza"
  },
  {
    "value": "Asia/Hebron",
    "text": "Ásia / Hebron"
  },
  {
    "value": "Asia/Hong_Kong",
    "text": "Ásia / Hong Kong"
  },
  {
    "value": "Asia/Hovd",
    "text": "Ásia / Hovd"
  },
  {
    "value": "Asia/Irkutsk",
    "text": "Ásia / Irkutsk"
  },
  {
    "value": "Asia/Jakarta",
    "text": "Ásia / Jakarta"
  },
  {
    "value": "Asia/Jayapura",
    "text": "Ásia / Jayapura"
  },
  {
    "value": "Asia/Jerusalem",
    "text": "Ásia / Jerusalem"
  },
  {
    "value": "Asia/Kabul",
    "text": "Ásia / Kabul"
  },
  {
    "value": "Asia/Kamchatka",
    "text": "Ásia / Kamchatka"
  },
  {
    "value": "Asia/Karachi",
    "text": "Ásia / Karachi"
  },
  {
    "value": "Asia/Katmandu",
    "text": "Ásia / Katmandu"
  },
  {
    "value": "Asia/Khandyga",
    "text": "Ásia / Khandyga"
  },
  {
    "value": "Asia/Krasnoyarsk",
    "text": "Ásia / Krasnoyarsk"
  },
  {
    "value": "Asia/Kuala_Lumpur",
    "text": "Ásia / Kuala Lumpur"
  },
  {
    "value": "Asia/Kuching",
    "text": "Ásia / Kuching"
  },
  {
    "value": "Asia/Kuwait",
    "text": "Ásia / Kuwait"
  },
  {
    "value": "Asia/Macau",
    "text": "Ásia / Macau"
  },
  {
    "value": "Asia/Magadan",
    "text": "Ásia / Magadan"
  },
  {
    "value": "Asia/Makassar",
    "text": "Ásia / Makassar"
  },
  {
    "value": "Asia/Manila",
    "text": "Ásia / Manila"
  },
  {
    "value": "Asia/Muscat",
    "text": "Ásia / Muscat"
  },
  {
    "value": "Asia/Nicosia",
    "text": "Ásia / Nicosia"
  },
  {
    "value": "Asia/Novokuznetsk",
    "text": "Ásia / Novokuznetsk"
  },
  {
    "value": "Asia/Novosibirsk",
    "text": "Ásia / Novosibirsk"
  },
  {
    "value": "Asia/Omsk",
    "text": "Ásia / Omsk"
  },
  {
    "value": "Asia/Oral",
    "text": "Ásia / Oral"
  },
  {
    "value": "Asia/Phnom_Penh",
    "text": "Ásia / Phnom Penh"
  },
  {
    "value": "Asia/Pontianak",
    "text": "Ásia / Pontianak"
  },
  {
    "value": "Asia/Pyongyang",
    "text": "Ásia / Pyongyang"
  },
  {
    "value": "Asia/Qatar",
    "text": "Ásia / Qatar"
  },
  {
    "value": "Asia/Qostanay",
    "text": "Ásia / Qostanay"
  },
  {
    "value": "Asia/Qyzylorda",
    "text": "Ásia / Qyzylorda"
  },
  {
    "value": "Asia/Rangoon",
    "text": "Ásia / Rangoon"
  },
  {
    "value": "Asia/Riyadh",
    "text": "Ásia / Riyadh"
  },
  {
    "value": "Asia/Saigon",
    "text": "Ásia / Saigon"
  },
  {
    "value": "Asia/Sakhalin",
    "text": "Ásia / Sakhalin"
  },
  {
    "value": "Asia/Samarkand",
    "text": "Ásia / Samarkand"
  },
  {
    "value": "Asia/Seoul",
    "text": "Ásia / Seoul"
  },
  {
    "value": "Asia/Shanghai",
    "text": "Ásia / Shanghai"
  },
  {
    "value": "Asia/Singapore",
    "text": "Ásia / Singapore"
  },
  {
    "value": "Asia/Srednekolymsk",
    "text": "Ásia / Srednekolymsk"
  },
  {
    "value": "Asia/Taipei",
    "text": "Ásia / Taipei"
  },
  {
    "value": "Asia/Tashkent",
    "text": "Ásia / Tashkent"
  },
  {
    "value": "Asia/Tbilisi",
    "text": "Ásia / Tbilisi"
  },
  {
    "value": "Asia/Tehran",
    "text": "Ásia / Tehran"
  },
  {
    "value": "Asia/Thimphu",
    "text": "Ásia / Thimphu"
  },
  {
    "value": "Asia/Tokyo",
    "text": "Ásia / Tokyo"
  },
  {
    "value": "Asia/Tomsk",
    "text": "Ásia / Tomsk"
  },
  {
    "value": "Asia/Ulaanbaatar",
    "text": "Ásia / Ulaanbaatar"
  },
  {
    "value": "Asia/Urumqi",
    "text": "Ásia / Urumqi"
  },
  {
    "value": "Asia/Ust-Nera",
    "text": "Ásia / Ust-Nera"
  },
  {
    "value": "Asia/Vientiane",
    "text": "Ásia / Vientiane"
  },
  {
    "value": "Asia/Vladivostok",
    "text": "Ásia / Vladivostok"
  },
  {
    "value": "Asia/Yakutsk",
    "text": "Ásia / Yakutsk"
  },
  {
    "value": "Asia/Yekaterinburg",
    "text": "Ásia / Yekaterinburg"
  },
  {
    "value": "Asia/Yerevan",
    "text": "Ásia / Yerevan"
  },
  {
    "value": "Atlantic/Azores",
    "text": "Atlântico / Azores"
  },
  {
    "value": "Atlantic/Bermuda",
    "text": "Atlântico / Bermuda"
  },
  {
    "value": "Atlantic/Canary",
    "text": "Atlântico / Canary"
  },
  {
    "value": "Atlantic/Cape_Verde",
    "text": "Atlântico / Cape Verde"
  },
  {
    "value": "Atlantic/Faeroe",
    "text": "Atlântico / Faeroe"
  },
  {
    "value": "Atlantic/Madeira",
    "text": "Atlântico / Madeira"
  },
  {
    "value": "Atlantic/Reykjavik",
    "text": "Atlântico / Reykjavik"
  },
  {
    "value": "Atlantic/South_Georgia",
    "text": "Atlântico / South Georgia"
  },
  {
    "value": "Atlantic/St_Helena",
    "text": "Atlântico / St Helena"
  },
  {
    "value": "Atlantic/Stanley",
    "text": "Atlântico / Stanley"
  },
  {
    "value": "Australia/Adelaide",
    "text": "Austrália / Adelaide"
  },
  {
    "value": "Australia/Brisbane",
    "text": "Austrália / Brisbane"
  },
  {
    "value": "Australia/Broken_Hill",
    "text": "Austrália / Broken Hill"
  },
  {
    "value": "Australia/Darwin",
    "text": "Austrália / Darwin"
  },
  {
    "value": "Australia/Eucla",
    "text": "Austrália / Eucla"
  },
  {
    "value": "Australia/Hobart",
    "text": "Austrália / Hobart"
  },
  {
    "value": "Australia/Lindeman",
    "text": "Austrália / Lindeman"
  },
  {
    "value": "Australia/Lord_Howe",
    "text": "Austrália / Lord Howe"
  },
  {
    "value": "Australia/Melbourne",
    "text": "Austrália / Melbourne"
  },
  {
    "value": "Australia/Perth",
    "text": "Austrália / Perth"
  },
  {
    "value": "Australia/Sydney",
    "text": "Austrália / Sydney"
  },
  {
    "value": "Europe/Amsterdam",
    "text": "Europa / Amsterdam"
  },
  {
    "value": "Europe/Andorra",
    "text": "Europa / Andorra"
  },
  {
    "value": "Europe/Astrakhan",
    "text": "Europa / Astrakhan"
  },
  {
    "value": "Europe/Athens",
    "text": "Europa / Athens"
  },
  {
    "value": "Europe/Belgrade",
    "text": "Europa / Belgrade"
  },
  {
    "value": "Europe/Berlin",
    "text": "Europa / Berlin"
  },
  {
    "value": "Europe/Bratislava",
    "text": "Europa / Bratislava"
  },
  {
    "value": "Europe/Brussels",
    "text": "Europa / Brussels"
  },
  {
    "value": "Europe/Bucharest",
    "text": "Europa / Bucharest"
  },
  {
    "value": "Europe/Budapest",
    "text": "Europa / Budapest"
  },
  {
    "value": "Europe/Busingen",
    "text": "Europa / Busingen"
  },
  {
    "value": "Europe/Chisinau",
    "text": "Europa / Chisinau"
  },
  {
    "value": "Europe/Copenhagen",
    "text": "Europa / Copenhagen"
  },
  {
    "value": "Europe/Dublin",
    "text": "Europa / Dublin"
  },
  {
    "value": "Europe/Gibraltar",
    "text": "Europa / Gibraltar"
  },
  {
    "value": "Europe/Guernsey",
    "text": "Europa / Guernsey"
  },
  {
    "value": "Europe/Helsinki",
    "text": "Europa / Helsinki"
  },
  {
    "value": "Europe/Isle_of_Man",
    "text": "Europa / Isle Of Man"
  },
  {
    "value": "Europe/Istanbul",
    "text": "Europa / Istanbul"
  },
  {
    "value": "Europe/Jersey",
    "text": "Europa / Jersey"
  },
  {
    "value": "Europe/Kaliningrad",
    "text": "Europa / Kaliningrad"
  },
  {
    "value": "Europe/Kiev",
    "text": "Europa / Kiev"
  },
  {
    "value": "Europe/Kirov",
    "text": "Europa / Kirov"
  },
  {
    "value": "Europe/Lisbon",
    "text": "Europa / Lisbon"
  },
  {
    "value": "Europe/Ljubljana",
    "text": "Europa / Ljubljana"
  },
  {
    "value": "Europe/London",
    "text": "Europa / London"
  },
  {
    "value": "Europe/Luxembourg",
    "text": "Europa / Luxembourg"
  },
  {
    "value": "Europe/Madrid",
    "text": "Europa / Madrid"
  },
  {
    "value": "Europe/Malta",
    "text": "Europa / Malta"
  },
  {
    "value": "Europe/Mariehamn",
    "text": "Europa / Mariehamn"
  },
  {
    "value": "Europe/Minsk",
    "text": "Europa / Minsk"
  },
  {
    "value": "Europe/Monaco",
    "text": "Europa / Monaco"
  },
  {
    "value": "Europe/Moscow",
    "text": "Europa / Moscow"
  },
  {
    "value": "Europe/Oslo",
    "text": "Europa / Oslo"
  },
  {
    "value": "Europe/Paris",
    "text": "Europa / Paris"
  },
  {
    "value": "Europe/Podgorica",
    "text": "Europa / Podgorica"
  },
  {
    "value": "Europe/Prague",
    "text": "Europa / Prague"
  },
  {
    "value": "Europe/Riga",
    "text": "Europa / Riga"
  },
  {
    "value": "Europe/Rome",
    "text": "Europa / Rome"
  },
  {
    "value": "Europe/Samara",
    "text": "Europa / Samara"
  },
  {
    "value": "Europe/San_Marino",
    "text": "Europa / San Marino"
  },
  {
    "value": "Europe/Sarajevo",
    "text": "Europa / Sarajevo"
  },
  {
    "value": "Europe/Saratov",
    "text": "Europa / Saratov"
  },
  {
    "value": "Europe/Simferopol",
    "text": "Europa / Simferopol"
  },
  {
    "value": "Europe/Skopje",
    "text": "Europa / Skopje"
  },
  {
    "value": "Europe/Sofia",
    "text": "Europa / Sofia"
  },
  {
    "value": "Europe/Stockholm",
    "text": "Europa / Stockholm"
  },
  {
    "value": "Europe/Tallinn",
    "text": "Europa / Tallinn"
  },
  {
    "value": "Europe/Tirane",
    "text": "Europa / Tirane"
  },
  {
    "value": "Europe/Ulyanovsk",
    "text": "Europa / Ulyanovsk"
  },
  {
    "value": "Europe/Vaduz",
    "text": "Europa / Vaduz"
  },
  {
    "value": "Europe/Vatican",
    "text": "Europa / Vatican"
  },
  {
    "value": "Europe/Vienna",
    "text": "Europa / Vienna"
  },
  {
    "value": "Europe/Vilnius",
    "text": "Europa / Vilnius"
  },
  {
    "value": "Europe/Volgograd",
    "text": "Europa / Volgograd"
  },
  {
    "value": "Europe/Warsaw",
    "text": "Europa / Warsaw"
  },
  {
    "value": "Europe/Zagreb",
    "text": "Europa / Zagreb"
  },
  {
    "value": "Europe/Zurich",
    "text": "Europa / Zurich"
  },
  {
    "value": "Indian/Antananarivo",
    "text": "Índico / Antananarivo"
  },
  {
    "value": "Indian/Chagos",
    "text": "Índico / Chagos"
  },
  {
    "value": "Indian/Christmas",
    "text": "Índico / Christmas"
  },
  {
    "value": "Indian/Cocos",
    "text": "Índico / Cocos"
  },
  {
    "value": "Indian/Comoro",
    "text": "Índico / Comoro"
  },
  {
    "value": "Indian/Kerguelen",
    "text": "Índico / Kerguelen"
  },
  {
    "value": "Indian/Mahe",
    "text": "Índico / Mahe"
  },
  {
    "value": "Indian/Maldives",
    "text": "Índico / Maldives"
  },
  {
    "value": "Indian/Mauritius",
    "text": "Índico / Mauritius"
  },
  {
    "value": "Indian/Mayotte",
    "text": "Índico / Mayotte"
  },
  {
    "value": "Indian/Reunion",
    "text": "Índico / Reunion"
  },
  {
    "value": "Pacific/Apia",
    "text": "Pacífico / Apia"
  },
  {
    "value": "Pacific/Auckland",
    "text": "Pacífico / Auckland"
  },
  {
    "value": "Pacific/Bougainville",
    "text": "Pacífico / Bougainville"
  },
  {
    "value": "Pacific/Chatham",
    "text": "Pacífico / Chatham"
  },
  {
    "value": "Pacific/Easter",
    "text": "Pacífico / Easter"
  },
  {
    "value": "Pacific/Efate",
    "text": "Pacífico / Efate"
  },
  {
    "value": "Pacific/Enderbury",
    "text": "Pacífico / Enderbury"
  },
  {
    "value": "Pacific/Fakaofo",
    "text": "Pacífico / Fakaofo"
  },
  {
    "value": "Pacific/Fiji",
    "text": "Pacífico / Fiji"
  },
  {
    "value": "Pacific/Funafuti",
    "text": "Pacífico / Funafuti"
  },
  {
    "value": "Pacific/Galapagos",
    "text": "Pacífico / Galapagos"
  },
  {
    "value": "Pacific/Gambier",
    "text": "Pacífico / Gambier"
  },
  {
    "value": "Pacific/Guadalcanal",
    "text": "Pacífico / Guadalcanal"
  },
  {
    "value": "Pacific/Guam",
    "text": "Pacífico / Guam"
  },
  {
    "value": "Pacific/Honolulu",
    "text": "Pacífico / Honolulu"
  },
  {
    "value": "Pacific/Kiritimati",
    "text": "Pacífico / Kiritimati"
  },
  {
    "value": "Pacific/Kosrae",
    "text": "Pacífico / Kosrae"
  },
  {
    "value": "Pacific/Kwajalein",
    "text": "Pacífico / Kwajalein"
  },
  {
    "value": "Pacific/Majuro",
    "text": "Pacífico / Majuro"
  },
  {
    "value": "Pacific/Marquesas",
    "text": "Pacífico / Marquesas"
  },
  {
    "value": "Pacific/Midway",
    "text": "Pacífico / Midway"
  },
  {
    "value": "Pacific/Nauru",
    "text": "Pacífico / Nauru"
  },
  {
    "value": "Pacific/Niue",
    "text": "Pacífico / Niue"
  },
  {
    "value": "Pacific/Norfolk",
    "text": "Pacífico / Norfolk"
  },
  {
    "value": "Pacific/Noumea",
    "text": "Pacífico / Noumea"
  },
  {
    "value": "Pacific/Pago_Pago",
    "text": "Pacífico / Pago Pago"
  },
  {
    "value": "Pacific/Palau",
    "text": "Pacífico / Palau"
  },
  {
    "value": "Pacific/Pitcairn",
    "text": "Pacífico / Pitcairn"
  },
  {
    "value": "Pacific/Ponape",
    "text": "Pacífico / Ponape"
  },
  {
    "value": "Pacific/Port_Moresby",
    "text": "Pacífico / Port Moresby"
  },
  {
    "value": "Pacific/Rarotonga",
    "text": "Pacífico / Rarotonga"
  },
  {
    "value": "Pacific/Saipan",
    "text": "Pacífico / Saipan"
  },
  {
    "value": "Pacific/Tahiti",
    "text": "Pacífico / Tahiti"
  },
  {
    "value": "Pacific/Tarawa",
    "text": "Pacífico / Tarawa"
  },
  {
    "value": "Pacific/Tongatapu",
    "text": "Pacífico / Tongatapu"
  },
  {
    "value": "Pacific/Truk",
    "text": "Pacífico / Truk"
  },
  {
    "value": "Pacific/Wake",
    "text": "Pacífico / Wake"
  },
  {
    "value": "Pacific/Wallis",
    "text": "Pacífico / Wallis"
  }
]
};
